import styled from 'styled-components';
import { FONT_FAMILY, DEVICES, COLORS } from '@Commons';

export const DashboardInfoCard = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 24px;
  gap: 16px;
  border-radius: 16px;
  background: ${COLORS.white};
  flex: 1;
  max-width: 520px;

  @media ${DEVICES.mobileXL} {
    flex: unset;
    width: 100%;
    max-width: 100%;
  }
`;

export const CardCTA = styled.span`
  font-size: 18px;
  cursor: pointer;
  color: ${COLORS.darkBlue};
  font-family: ${FONT_FAMILY.hellix.bold};
  margin-top: 4px;
`;

export const InstaPointsBentoCard = styled.div`
  background: ${COLORS.white};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  overflow: hidden;
`;

export const ReferralBentoCard = styled.div`
  background: ${COLORS.shadeLavender};
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 160px;
`;

export const BentoHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
`;

export const BentoTitle = styled.p`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.black};
`;

export const BentoCTA = styled.span`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 16px;
  line-height: 26px;
  color: ${COLORS.darkBlue};
  cursor: pointer;
  white-space: nowrap;
`;

export const InstaPointOverviewRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  flex: 1;
`;

export const InstaPointOverviewCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
`;

export const InstaPointOverviewLabel = styled.p`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.textGrey};
  white-space: nowrap;
`;

export const InstaPointPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${COLORS.lightBlueBackground};
  border: 1px solid ${COLORS.lightborderBlue};
  border-radius: 400px;
  padding: 2px 12px;
`;

export const InstaPointPillIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export const InstaPointPillText = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.black};
`;

export const InstaPointVerticalDivider = styled.div`
  width: 1px;
  background: ${COLORS.borderbottom};
  align-self: stretch;
  flex-shrink: 0;
`;

export const ReferralTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
`;

export const ReferralCardTitle = styled.p`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 24px;
  color: ${COLORS.black};
`;

export const ReferralCardSubtitle = styled.p`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 24px;
  color: ${COLORS.textGrey};
`;
